import React from "react";
import Alert from "@visa/vds/alert";
import AlertIcon from "@visa/vds/alert-icon";
import AlertLabel from "@visa/vds/alert-label";
import AlertLabelTitle from "@visa/vds/alert-label-title";
import ButtonContainer from "@visa/vds/button-container";
import ButtonGroup from "@visa/vds/button-group";
import ButtonIcon from "@visa/vds/button-icon";
import Grid from "@visa/vds/grid";
import Row from "@visa/vds/row";
import Col from "@visa/vds/col";
import Icon from "@visa/vds/icon";

const MCSAlertGlobalError = (props) => {
  return (
    props.errorMessage !== "" &&
    props.showAlert && (
      <Alert
        id="alert-default-error-global"
        show={props.showAlert}
        position="absolute"
        alertType="error"
      >
        <Grid>
          <Row>
            <Col>
              <AlertIcon>
                <Icon name="error" resolution="low" />
              </AlertIcon>
              <AlertLabel>
                <AlertLabelTitle>{"Error: " + props.errorMessage}</AlertLabelTitle>
                There has been an error processing your request. Please try again later.
              </AlertLabel>
            </Col>
            <Col sm={1}>
              <ButtonContainer>
                <ButtonGroup direction="right">
                  <ButtonIcon ariaLabel="close" iconType="light-tiny"
                    onClick={() => {
                      props.hideAlert();
                    }}
                  >
                    <Icon name="close" resolution="tiny" />
                  </ButtonIcon>
                </ButtonGroup>
              </ButtonContainer>
            </Col>
          </Row>
        </Grid>
      </Alert>
    )
  );
};

export default MCSAlertGlobalError;
